module.exports = "/_next/static/files/122e58b778ead2c4ce2a5550be8351c3.png";